<template>
  <div class="movie-box f-3 fc-gray-2">
    <div class="movie-box-left as-flex flex-vertical main-center cross-center">
      <div class="title-row f-3">{{movieInfo.title||'--'}}</div>
      <div class="type-row as-flex flex-horizontal main-start cross-center f-2">
        <div
          class="box-time"
        >{{movieInfo.launch||'--:--:--'}} ({{weekMapping[movieInfo.day]||'--:--:--'}})</div>
        <template v-for="(item,index) in (movieInfo.tags||[])">
          <div :key="item.id" :class="['box-type',index===0?'is-first':'']">{{item.name}}</div>
        </template>
      </div>
      <div
        v-if="movieInfo.box !== '--' || movieInfo.first_week_box !== '--'"
        class="box-row as-flex flex-horizontal main-start cross-center f-2"
      >
        <div class="total-box">综合票房: {{movieInfo.box}}</div>
        <div class="first-week-box">首周票房: {{movieInfo.first_week_box}}</div>
      </div>
    </div>
    <div
      v-if="!isTracking"
      class="movie-box-right as-flex main-around cross-center f-2 fc-gray-2"
    >暂未监测(发起需求)</div>
    <div v-else class="movie-box-right as-flex main-around cross-center f-2">
      <div class="awareness-box as-flex flex-vertical main-center cross-center">
        <div
          v-if="!isLatest"
          class="cycle as-flex flex-horizontal main-center cross-center"
        >({{offsetMaaping[movieInfo.result.offset]}})</div>
        <div
          v-if="['0.0','-1.0','-2.0','-3.0','-4.0','--'].includes(movieInfo.result.offset)"
          class="tag1 f-3"
        >{{movieInfo.result.awareness.value!=='--'?`${movieInfo.result.awareness.value}%`:'--'}}</div>

        <div v-if="movieInfo.result.awareness.difference !== '--'" class="cycle">
          较上周
          <span
            :class="returnDiffColorClass(movieInfo.result.awareness.difference)"
          >{{returnFormatDiffValue(movieInfo.result.awareness.difference)}}</span>
        </div>
      </div>
      <div class="primary-box as-flex flex-vertical main-center cross-center">
        <div
          v-if="!isLatest"
          class="cycle as-flex flex-horizontal main-center cross-center"
        >({{offsetMaaping[movieInfo.result.offset]}})</div>
        <div
          v-if="['0.0','-1.0','-2.0','-3.0','-4.0','--'].includes(movieInfo.result.offset)"
          class="tag1 f-3"
        >{{movieInfo.result.primary.value!=='--'?`${movieInfo.result.primary.value}%`:'--'}}</div>
        <div v-if="movieInfo.result.primary.difference !== '--'" class="cycle">
          较上周
          <span
            :class="returnDiffColorClass(movieInfo.result.primary.difference)"
          >{{returnFormatDiffValue(movieInfo.result.primary.difference)}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const offsetMaaping = {
  "-1.0": "映前1周",
  "-2.0": "映前2周",
  "-3.0": "映前3周",
  "-4.0": "映前4周",
  "0.0": "上映当周",
  "1.0": "映后1周"
  // "2.0": "映后2周"
};
const weekMapping = {
  1: "周一",
  2: "周二",
  3: "周三",
  4: "周四",
  5: "周五",
  6: "周六",
  7: "周日"
};
export default {
  name: "movieBox",
  props: {
    movieInfo: { default: {} },
    type: { default: "single" },
    isLatest: {},
    isTracking: {}
  },
  data() {
    return {
      offsetMaaping: offsetMaaping,
      weekMapping: weekMapping,
      newestOffset: undefined
    };
  },
  methods: {
    returnDiffColorClass(value) {
      if (value > 0) {
        return "as-green";
      } else if (value < 0) {
        return "as-red";
      } else {
        return "as-gray";
      }
    },
    returnFormatDiffValue(value) {
      if (value > 0) {
        return "+" + Number(value).toFixed(1);
      } else if (value < 0) {
        return Number(value).toFixed(1);
      } else {
        return Number(value).toFixed(1);
      }
    }
  },
  computed: {},
  created() {
    // console.log(this.movieInfo);
  },
  watch: {}
};
</script>

<style lang="scss" scoped>
.movie-box {
  position: relative;
  height: 100%;
  width: 100%;
  padding: 10px 0;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.movie-box-left {
  height: 100%;
  width: 50%;
}
.movie-box-right {
  height: 100%;
  width: 50%;
}
.awareness-box {
  height: 100%;
  width: 50%;
}
.primary-box {
  height: 100%;
  width: 50%;
}
.title-row {
  height: 51px;
  line-height: 51px;
  width: 100%;
  color: #333333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.box-row {
  height: 40px;
  width: 100%;
  color: #666666;
  white-space: nowrap;
  .total-box {
    margin-right: 10px;
  }
}
.type-row {
  height: 40px;
  width: 100%;
  color: #666666;
  white-space: nowrap;
  margin-left: -10px;
  .box-type {
    border-left: 1px solid #666666;
    // line-height: 100%;
    padding: 0 10px;
    &.is-first {
      border-left: 1px solid rgba(0, 0, 0, 0);
    }
  }
  .box-tag {
    // line-height: 100%;
    padding-right: 10px;
  }
  .box-time {
    // line-height: 100%;
    padding: 0 5px;
  }
}
.as-red {
  color: #d0021b;
}
.as-green {
  color: #5a9d0d;
}
.as-gray {
  color: #666666;
}
.tag-row {
  height: 50px;
  width: 100%;
  white-space: nowrap;
  color: #666666;
  .tag1 {
    line-height: 100%;
    padding-right: 10px;
    margin-right: 20px;
  }
  .tag2 {
    line-height: 100%;
    padding-right: 10px;
    margin-right: 20px;
  }
  .tag3 {
    line-height: 100%;
    padding-right: 10px;
    margin-right: 20px;
  }
}
.cycle {
  color: #666666;
}
</style>
